import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const updateSettings = async (obj) => {
  try {
    let { status } = await axios.put(`/v1/worker/settings`, obj);
    return status;
  } catch (e) {
    console.log("error while updating worker ....", e.response);
        addNotification({
            title: "Techforce.ai",
            message: "Please write for technical support",
            type: "danger",
          });
    }
};
